import React, { useEffect, useState } from "react";
import { axiosMaster, axiosSalary } from "../api/axiosInstance";

const AddEditAttendancePolicy = ({
  editData,
  selectedRestId,
  groupId,
  onClose,
  onSave,
}) => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userId = user?.userId || 0;

  /* ================= PUNCH HANDLING MODE OPTIONS ================= */
  const punchHandlingOptions = [
    { label: "Auto Punch Out", value: "AUTO_PUNCH_OUT" },
    { label: "Suspense", value: "SUSPENSE" },
  ];

  const [form, setForm] = useState({
    fullDayMinPercent: 0,
    halfDayMinPercent: 0,
    quarterDayMinPercent: 0,
    isQuarterDayEnabled: true,
    openShiftPunchHandlingMode: "AUTO_PUNCH_OUT",
    reportingShiftPunchHandlingMode: "AUTO_PUNCH_OUT",
    closedShiftPunchHandlingMode: "AUTO_PUNCH_OUT",
    breakShiftPunchHandlingMode: "AUTO_PUNCH_OUT",
    monthlyLeaveCredit: 0,
    weeklyOffPaid: true,
    salaryCalculationMode: "WorkingMinutes",
    unusedLeaveSettlementMode: "CashWithSalary",
    leaveEncashRatePercent: 0,
    remarks: "",
  });

  useEffect(() => {
    if (editData) {
      setForm({
        fullDayMinPercent: editData.fullDayMinPercent ?? 0,
        halfDayMinPercent: editData.halfDayMinPercent ?? 0,
        quarterDayMinPercent: editData.quarterDayMinPercent ?? 0,
        isQuarterDayEnabled: editData.isQuarterDayEnabled ?? true,
        openShiftPunchHandlingMode:
          editData.openShiftPunchHandlingMode || "AUTO_PUNCH_OUT",
        reportingShiftPunchHandlingMode:
          editData.reportingShiftPunchHandlingMode || "AUTO_PUNCH_OUT",
        closedShiftPunchHandlingMode:
          editData.closedShiftPunchHandlingMode || "AUTO_PUNCH_OUT",
        breakShiftPunchHandlingMode:
          editData.breakShiftPunchHandlingMode || "AUTO_PUNCH_OUT",
        monthlyLeaveCredit: editData.monthlyLeaveCredit ?? 0,
        weeklyOffPaid: editData.weeklyOffPaid ?? true,
        salaryCalculationMode:
          editData.salaryCalculationMode || "WorkingMinutes",
        unusedLeaveSettlementMode:
          editData.unusedLeaveSettlementMode || "CashWithSalary",
        leaveEncashRatePercent: editData.leaveEncashRatePercent ?? 0,
        remarks: editData.remarks || "",
      });
    }
  }, [editData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : type === "number"
          ? Number(value)
          : value,
    }));
  };

  const handleSubmit = () => {
    const payload = {
      id: editData?.id || 0,
      groupId,
      restId: Number(selectedRestId),
      fullDayMinPercent: Number(form.fullDayMinPercent),
      halfDayMinPercent: Number(form.halfDayMinPercent),
      quarterDayMinPercent: Number(form.quarterDayMinPercent),
      isQuarterDayEnabled: form.isQuarterDayEnabled,
      openShiftPunchHandlingMode: form.openShiftPunchHandlingMode,
      reportingShiftPunchHandlingMode: form.reportingShiftPunchHandlingMode,
      closedShiftPunchHandlingMode: form.closedShiftPunchHandlingMode,
      breakShiftPunchHandlingMode: form.breakShiftPunchHandlingMode,
      monthlyLeaveCredit: Number(form.monthlyLeaveCredit),
      weeklyOffPaid: form.weeklyOffPaid,
      unusedLeaveSettlementMode: form.unusedLeaveSettlementMode,
      leaveEncashRatePercent: Number(form.leaveEncashRatePercent),
      salaryCalculationMode: form.salaryCalculationMode,
      remarks: form.remarks,
      userId,
    };

    onSave(payload);
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
      <div className="bg-white rounded-xl w-full max-w-3xl mx-4 p-5 max-h-[90vh] overflow-auto">
        <h2 className="text-xl font-bold mb-5">Attendance Policy</h2>

        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <label className="text-sm font-medium">Full Day Minimum %</label>
            <input
              type="number"
              name="fullDayMinPercent"
              value={form.fullDayMinPercent}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
            />
          </div>

          <div>
            <label className="text-sm font-medium">Half Day Minimum %</label>
            <input
              type="number"
              name="halfDayMinPercent"
              value={form.halfDayMinPercent}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
            />
          </div>

          <div>
            <label className="text-sm font-medium">Quarter Day Minimum %</label>
            <input
              type="number"
              name="quarterDayMinPercent"
              value={form.quarterDayMinPercent}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
            />
          </div>

          <div>
            <label className="text-sm font-medium">Monthly Leave Credit</label>
            <input
              type="number"
              name="monthlyLeaveCredit"
              value={form.monthlyLeaveCredit}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
            />
          </div>

          {/* ===== PUNCH HANDLING MODE SELECTS ===== */}
          <div>
            <label className="text-sm font-medium">
              Open Shift Punch Handling Mode
            </label>
            <select
              name="openShiftPunchHandlingMode"
              value={form.openShiftPunchHandlingMode}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
            >
              {punchHandlingOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-sm font-medium">
              Reporting Shift Punch Handling Mode
            </label>
            <select
              name="reportingShiftPunchHandlingMode"
              value={form.reportingShiftPunchHandlingMode}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
            >
              {punchHandlingOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-sm font-medium">
              Closed Shift Punch Handling Mode
            </label>
            <select
              name="closedShiftPunchHandlingMode"
              value={form.closedShiftPunchHandlingMode}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
            >
              {punchHandlingOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-sm font-medium">
              Break Shift Punch Handling Mode
            </label>
            <select
              name="breakShiftPunchHandlingMode"
              value={form.breakShiftPunchHandlingMode}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
            >
              {punchHandlingOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-sm font-medium">
              Salary Calculation Mode
            </label>
            <select
              name="salaryCalculationMode"
              value={form.salaryCalculationMode}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
            >
              <option value="AllowedValues">Allowed Values</option>
              <option value="AttendanceCredit">Attendance Credit</option>
              <option value="WorkingMinutes">Working Minutes</option>
            </select>
          </div>

          <div>
            <label className="text-sm font-medium">
              Leave Settlement Mode
            </label>
            <select
              name="unusedLeaveSettlementMode"
              value={form.unusedLeaveSettlementMode}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
            >
              <option value="CashWithSalary">Cash With Salary</option>
              <option value="CarryForward">Carry Forward</option>
              <option value="EncashDifferentRate">
                Encash Different Rate
              </option>
            </select>
          </div>

          <div>
            <label className="text-sm font-medium">Leave Encash Rate %</label>
            <input
              type="number"
              name="leaveEncashRatePercent"
              value={form.leaveEncashRatePercent}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
            />
          </div>

          <div className="flex items-center gap-2 mt-7">
            <input
              type="checkbox"
              name="isQuarterDayEnabled"
              checked={form.isQuarterDayEnabled}
              onChange={handleChange}
            />
            <label>Quarter Day Enabled</label>
          </div>

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              name="weeklyOffPaid"
              checked={form.weeklyOffPaid}
              onChange={handleChange}
            />
            <label>Weekly Off Paid</label>
          </div>

          <div className="md:col-span-2">
            <label className="text-sm font-medium">Remarks</label>
            <textarea
              rows={3}
              name="remarks"
              value={form.remarks}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
            />
          </div>
        </div>

        <div className="flex justify-end gap-2 mt-5">
          <button onClick={onClose} className="px-4 py-2 border rounded-lg">
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg"
          >
            Save Policy
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddEditAttendancePolicy;